<script setup>
import { formStore } from '@/stores/form';

const form = formStore();
</script>

<template>
  <div class="px-4 py-5">
    <!-- eslint-disable vue/no-v-html @intlify/vue-i18n/no-v-html -->
    <h3 v-html="$t('general.helpCenter.faqTitle', { tagopen: '<span>', vehicle: form.funnelType, tagclose: '</span>' })" />
    <!-- eslint-enable -->
    <div
      id="accordionFaq"
      class="accordion accordion-flush"
    >
      <div
        v-for="(faq, i) in form.getFaq"
        :key="i"
        class="accordion-item"
      >
        <div
          :id="`heading${faq.name}`"
          class="accordion-header"
        >
          <button
            class="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            :data-bs-target="`#collapse${faq.name}`"
            aria-expanded="false"
            :aria-controls="`collapse${faq.name}`"
          >
            <strong>{{ faq.question }}</strong>
          </button>
        </div>
        <div
          :id="`collapse${faq.name}`"
          class="accordion-collapse collapse"
          :aria-labelledby="`heading${faq.name}`"
          data-bs-parent="#accordionFaq"
        >
          <div class="accordion-body">
            <p>
              {{ faq.tekst }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.accordion {
  --bs-accordion-btn-bg: var(--theme-font-color-accent-25);
  --bs-accordion-active-bg: var(--theme-font-color-accent-25);
  --bs-accordion-active-color: unset;
  --bs-accordion-btn-focus-box-shadow: none;
  --bs-accordion-bg: var(--theme-font-color-accent-25);
}

.accordion-button {
  padding: 1.6rem 0 1.6rem 0;
}

.accordion-item {
  border-bottom: unset;
}
</style>
